const medical= {
    ALLOWED:1 ,
    NOT_ALLOWED:0
}


module.exports ={
    medical
}